import { initDiscoveryClient } from "@/api/apiClient";
import { getCanvasViewInsights as getCanvasViewInsightsRequest } from "@/api/openapi/discovery/sdk.gen";
import { toApiError, unwrapClientData } from "@/services/api";

export type InsightsTopic = {
  target_id: string;
  vote_count: number;
  comments: string[];
};

export type InsightsData = {
  voting_open: boolean;
  target_type: "theme" | "subtheme";
  total_votes: number;
  unique_voters: number;
  topics: InsightsTopic[];
};

export async function getInsights(params: { externalId: string; token?: string }): Promise<InsightsData> {
  const client = initDiscoveryClient();

  try {
    const response = await getCanvasViewInsightsRequest({
      client,
      path: { external_id: params.externalId },
      headers: params.token ? { Authorization: `Bearer ${params.token}` } : undefined,
    });
    return unwrapClientData<InsightsData>(response);
  } catch (error) {
    throw toApiError(error, "Failed to fetch insights data.");
  }
}
